export const POPULAR_CURRENCIES = ['USD', 'EUR', 'CAD', 'GBP'] as const;

const isPopularCurrency = (
  currency: string
): currency is (typeof POPULAR_CURRENCIES)[number] =>
  POPULAR_CURRENCIES.includes(currency as (typeof POPULAR_CURRENCIES)[number]);

const getSortedUniqueCurrencies = (currencies: string[]): string[] => {
  const unique = [...new Set(currencies)];
  const popular = POPULAR_CURRENCIES.filter((currency) =>
    unique.includes(currency)
  );
  const rest = unique
    .filter((currency) => !isPopularCurrency(currency))
    .sort((first, second) => first.localeCompare(second));

  return [...popular, ...rest];
};

export default getSortedUniqueCurrencies;
